export const WAV_WRITER_HEALTH_EVENT = 'WAV_WRITER_HEALTH_FAILED';

export type WavWriterSource = 'mic' | 'speaker';
export type WavWriterPhase =
  | 'create'
  | 'write'
  | 'finalFlush'
  | 'finalize'
  | 'channelFull'
  | 'channelClosed';
export type WavWriterReason =
  | 'storageFull'
  | 'quotaExceeded'
  | 'io'
  | 'timeout'
  | 'taskPanic'
  | 'writerUnavailable'
  | 'channelFull'
  | 'channelClosed';

export type WavWriterFailurePayload = {
  sessionId?: string | null;
  captureInstanceId: number;
  source: WavWriterSource;
  phase: WavWriterPhase;
  reason: WavWriterReason;
  errorCode: string;
  rawOsError?: number | null;
  attemptedSamples: number;
  /**
   * Absent when the failure was reported from outside the WAV writer itself —
   * the router's channel-full/closed paths, and the supervisor's
   * writer-unavailable/task-panic paths, which sit on the other side of the
   * writer's thread boundary and cannot read its committed counter.
   *
   * Absent is not zero. These paths used to send a literal 0, and anything
   * reading it concluded that a two-hour consultation had lost nothing.
   */
  committedSamples?: number;
  attemptedBytes: number;
  /** Absent for exactly the same failures as {@link committedSamples}. */
  committedBytes?: number;
  ts: number;
};

export function shouldAcceptWavWriterFailure(
  payload: WavWriterFailurePayload,
  activeSessionId: string | null,
  currentFailure?: WavWriterFailurePayload,
  captureHighWater = 0,
  acceptedAfterTs = 0
): boolean {
  if (!payload.sessionId || payload.sessionId !== activeSessionId) return false;
  if (currentFailure?.sessionId === activeSessionId) return false;
  if (payload.captureInstanceId < captureHighWater) return false;
  if (payload.ts < acceptedAfterTs) return false;
  return payload.source === 'mic' || payload.source === 'speaker';
}
